<div class="add-line" [class.disabled]="disabled" [attr.disabled]="disabled">
  <div class="line"></div>
  <div class="add-icon">
    @if (!iconTemplate) {
      <rt-icon name="add" />
    } @else {
      <ng-template [ngTemplateOutlet]="iconTemplate" />
    }
  </div>
  <div class="line"></div>
</div>
